import { render } from "./DocumentScannerDemo.vue?vue&type=template&id=63bd58e2&scoped=true"
import script from "./DocumentScannerDemo.vue?vue&type=script&lang=js"
export * from "./DocumentScannerDemo.vue?vue&type=script&lang=js"

import "./DocumentScannerDemo.vue?vue&type=style&index=0&id=63bd58e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bd58e2"]])

export default __exports__